export { default } from "./logOut";
